import React from 'react'

export default function Underline() {
    return (
        <svg
            height='100%'
            viewBox='0 0 36 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M28.9688 28.2656H7.03125C6.87656 28.2656 6.75 28.3852 6.75 28.5328V30.6703C6.75 30.818 6.87656 30.9375 7.03125 30.9375H28.9688C29.1234 30.9375 29.25 30.818 29.25 30.6703V28.5328C29.25 28.3852 29.1234 28.2656 28.9688 28.2656ZM18 25.5938C20.4398 25.5938 22.732 24.641 24.4617 22.9148C26.1914 21.1887 27.1406 18.893 27.1406 16.4531V5.48438C27.1406 5.25234 26.9508 5.0625 26.7188 5.0625H24.6094C24.3773 5.0625 24.1875 5.25234 24.1875 5.48438V16.4531C24.1875 19.8633 21.4102 22.6406 18 22.6406C14.5898 22.6406 11.8125 19.8633 11.8125 16.4531V5.48438C11.8125 5.25234 11.6227 5.0625 11.3906 5.0625H9.28125C9.04922 5.0625 8.85938 5.25234 8.85938 5.48438V16.4531C8.85938 18.893 9.81211 21.1852 11.5383 22.9148C13.2645 24.6445 15.5602 25.5938 18 25.5938Z'
                fill='black'
            />
        </svg>
    )
}
